<template lang="pug">
section#v-organizers.container
  h3 主辦單位
  .row
    img(src='@/assets/to-logo.png', alt='TechOrange 科技報橘', :width='$store.state.mobile ? 216 : 290')
  h3 指導單位
  .row
    img(src='@/assets/ndc-logo.png', alt='國家發展委員會', :width='$store.state.mobile ? 218 : 290')
  h3 主力協辦
  .row
    img(src='@/assets/kronos-logo.png', alt='kronos', :width='$store.state.mobile ? 120 : 151')
    img(src='@/assets/systalk-logo.png', alt='SYSTALK', :width='$store.state.mobile ? 161 : 207')
  h3 策展推動
  .row
    img(src='@/assets/aws-logo.png', alt='AWS', :height='$store.state.mobile ? 60 : 80')
    img(src='@/assets/delta-logo.png', alt='台達 DELTA', :height='$store.state.mobile ? 30 : 40')
    img(src='@/assets/faceheart-logo.png', alt='鉅怡智慧 FaceHeart', :height='$store.state.mobile ? 30 : 40')
    img(src='@/assets/goshare-logo.png', alt='GoShare', :height='$store.state.mobile ? 50 : 60')
  .row
    img(src='@/assets/geosat-logo.png', alt='經偉航太 GEOSAT', :height='$store.state.mobile ? 40 : 50')
    img(src='@/assets/kneron-logo.png', alt='耐能智慧 Kneron', :height='$store.state.mobile ? 50 : 70')
    img(src='@/assets/mantatech-logo.png', alt='Manta Technology 曼塔睿科技', :height='$store.state.mobile ? 40 : 50')
    img(src='@/assets/miniwiz-logo.png', alt='小智研發 Miniwiz', :height='$store.state.mobile ? 50 : 60')
    img(src='@/assets/osense-logo.png', alt='光禾感知 OSENSE', :height='$store.state.mobile ? 40 : 50')
  .row
    img(src='@/assets/taiwanmobile-logo.png', alt='台灣大哥大 Taiwan Mobile', :height='$store.state.mobile ? 30 : 40')
    img(src='@/assets/teamdoor-logo.png', alt='Teamdoor', :height='$store.state.mobile ? 25 : 35')
    img(src='@/assets/wemo-logo.png', alt='WeMo scooter', :height='$store.state.mobile ? 50 : 60')
  h3 共同響應
  .row
    img(src='@/assets/self-logo.png', alt='SELF', :width='$store.state.mobile ? 172 : 203')
    img(src='@/assets/foodpanda-logo.png', alt='foodpanda', :width='$store.state.mobile ? 137 : 191')
    img(src='@/assets/hilife-logo.png', alt='萊爾富 hi-life', :width='$store.state.mobile ? 160 : 200')
    img(src='@/assets/taihu-logo.png', alt='臺虎精釀 TAUHU BREWING', :width='$store.state.mobile ? 150 : 170')
</template>

<script>
export default {
  name: 'Organizer',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-organizers
  padding-bottom: 30px
  padding-top: 60px
h3
  +font(32px, white, null, .8px, bold, center)
  margin-bottom: 30px
.row
  +flex(center, center)
  margin-bottom: 60px
  img
    margin-left: 30px
    margin-right: 30px

@media (max-width: 1023px)
  #v-organizers
    padding-bottom: 0
    padding-top: 30px
  h3
    +font(24px, white, null, .6px)
    margin-bottom: 30px
  .row
    flex-direction: column
    img
      margin-left: 0
      margin-right: 0
      &:not(:last-child)
        margin-bottom: 30px
</style>
